export const CLAIMS_BY_REASONS_SAMPLE_DATA = [
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Deducted from Carrier',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Duplicate',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Partial Payment',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Payment',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Time Barred',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Withdrawn',
  },
];

export const CLAIMS_BY_STATUS_SAMPLE_DATA = [
  { label: 'Open', value: 234 },
  { label: 'Hold', value: 104 },
  { label: 'Closed', value: 345 },
];
